import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Stepper.css";
import UIStepper from "react-stepper-horizontal";

const Stepper = props => {
  const { className, ...other } = props;
  const stepperStyle = {
    circleTop: 0,
    defaultColor: "transparent",
    activeColor: "#112a42",
    completeColor: "transparent",
    circleFontSize: 16,
    circleFontColor: "#b8bfc6",
    defaultTitleColor: "#b8bfc6",
    completeTitleColor: "#b8bfc6",
    titleFontSize: 14,
    size: 25,
    defaultBarColor: "#B8BFC6",
    defaultBorderColor: "#B8BFC6",
    defaultBorderStyle: "solid",
    completeBorderColor: "#B8BFC6",
    completeBorderStyle: "solid",
    activeBorderColor: "#112A42",
    completeBarColor: "#B8BFC6",
    titleTop: 3
  };
  return (
    <div className={"ui-stepper " + className}>
      <div className="ui-stepper__stepper">
        <UIStepper {...other} {...stepperStyle} />
      </div>
    </div>
  );
};

Stepper.propTypes = {
  className: PropTypes.string
};

export default Stepper;



// WEBPACK FOOTER //
// ./src/components/UI/Stepper/Stepper.js